export default __webpack_public_path__ + "static/media/2281.0243719b.png";